import { createFileRoute } from '@tanstack/react-router';

import { ProceedingCreate } from '@/module/Author/Proceeding/ProceedingCreate';

export const Route = createFileRoute('/_auth/author/_author/proceeding/_proceeding/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ProceedingCreate />;
}
